import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import axios from 'axios'
import { LoadingState } from '../constants/Constants';
import { Student, StudentData } from './viewmodels/StudentViewModel';

const initialState: StudentData = {
    student: {} as Student,
    loadingState: LoadingState.Idle,
    isAuthenticated: false,
}

export const fetchStudent = createAsyncThunk('fetchStudent', async (id: number) => {
    let URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/students/' + id + '/' : '/api/students/' + id + '/'
    const response = await axios.get(URL)
    return response.data as Student
})

export const fetchResults = createAsyncThunk('fetchResults', async (id: number) => {
    let URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/results/' + id + '/' : '/api/results/' + id + '/'
    const response = await axios.get(URL)
    return response.data
})

const studentSlice = createSlice({
    name: 'student',
    initialState,
    reducers: {
        studentAuthStateSwap: (state, action: PayloadAction<boolean>) => {
            state.isAuthenticated = action.payload
        },
        clearStudentState: (state) => {
            state.student = initialState.student
            state.loadingState = initialState.loadingState
            state.isAuthenticated = initialState.isAuthenticated
        }
    },
    extraReducers:
        (builder) => {
            builder.addCase(fetchStudent.pending, (state) => {
                state.loadingState = LoadingState.Loading
            })
            builder.addCase(fetchStudent.fulfilled, (state, action) => {
                state.loadingState = LoadingState.Idle
                state.student = action.payload
            })
            builder.addCase(fetchResults.fulfilled, (state, action) => {
                state.student.results = action.payload.results
                state.student.answer_files = action.payload.answer_files
            })
        },
})


export const {
    actions: { studentAuthStateSwap, clearStudentState },
} = studentSlice;

export default studentSlice.reducer